import moment from 'moment';


const callStatuses = {
    'pending': {label: 'Ожидает', color: 'secondary'},
    'processing': {label: 'В процессе', color: 'primary'},
    'finished': {label: 'Завершён', color: 'success'}
};


export default {
    // Check if arrays are equals. Works only on scalar arrays.
    arraysEqual (a, b) {
        var i = a.length;
        if (i != b.length) return false;
        while (i--) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    },
    // Format full-sized phone number
    formatPhone (phone) {
        const m = phone.match(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/);
        if (m) {
            phone = `+${m[1]} (${m[2]}) ${m[3]}-${m[4]}-${m[5]}`;
        }
        return phone;
    },

    parseDate (isoStr) {
        return moment(isoStr);
    },

    fmtDateStr (isoStr) {
        return moment(isoStr).format('DD.MM.YY HH:mm');
    },

    fmtDate (date) {
        return date.format('DD.MM.YY HH:mm');
    },

    callStatus (status) {
        if (Object.prototype.hasOwnProperty.call(callStatuses, status)) {
            return callStatuses[status];
        }
        return {label: status, color: 'light'};
    },

    callStatusChoices () {
        const choices = [];
        for (const k in callStatuses) {
            choices.push({value: k, text: callStatuses[k].label});
        }
        return choices;
    }

};
